export default __webpack_public_path__ + "static/nawate-1-6890b13e33f2987d6f1779cb182d0c35.jpg";